"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCopyToClipboard = require("./useCopyToClipboard");
Object.keys(_useCopyToClipboard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCopyToClipboard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCopyToClipboard[key];
    }
  });
});